/** NamasteNetwork.ai double-N ticket mark. */
export default function BrandMark({ size = 36, className = "" }) {
  return (
    <span
      data-testid="brand-mark"
      className={`inline-flex items-center justify-center rounded-xl bg-primary text-primary-foreground shadow-sm ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 64 64"
        width={size * 0.78}
        height={size * 0.78}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.9 16.6h40.2v9.6a6.6 6.6 0 0 0 0 13.2V49H11.9v-9.6a6.6 6.6 0 0 0 0-13.2v-9.6Z"
          stroke="currentColor"
          strokeWidth="2.6"
          strokeLinejoin="round"
        />
        <path
          d="M21.4 42.1V22.8l11.3 19.3V22.8M32.7 42.1V22.8L43 42.1V22.8"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
